<main class="main-home-secton">
  <div class="event-main">
    <div class="container-fluid mt-4">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div *ngIf="roleValue == 'Admin'">
            <button class="back-btns mb-0" (click)="AdminBack()">
              <i class="fas fa-chevron-left"></i>
              <span class="ml-2">Back</span>
            </button>
          </div>
        </div>
        <div class="offset-1 col-lg-4 col-md-4 col-sm-12">
          <h1>Profile</h1>
        </div>
      </div>
      <div class="div-contents">
        <form action="" [formGroup]="profileForm">
          <p class="sub-title">
            Incubator centre
            <span class="float-right"
              >Incubator ID : <b>{{ add.uniqueId.value }}</b></span
            >
          </p>
          <div class="row">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Name of the Incubator
                        <span class="text-danger">*</span></mat-label
                      >
                      <input
                        matInput
                        placeholder="Enter Name of the Incubator"
                        formControlName="incubatorName"
                        [readonly]="roleValue === 'Incubator'"
                        oninput="this.value = this.value.replace(/[^a-zA-Z0-9/ ]/g,'')"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorName.touched &&
                            add.incubatorName.errors
                        }"
                      />
                      <mat-error
                        *ngIf="
                          add.incubatorName.touched && add.incubatorName.errors
                        "
                      >
                        <span *ngIf="add.incubatorName.errors.required"
                          >Name of the Incubator is required</span
                        >
                        <span *ngIf="add.incubatorName?.errors?.pattern">
                          Enter Valid Name (or) Whitespace not allowed
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Incubator Email ID<span class="text-danger"
                          >*</span
                        ></mat-label
                      >
                      <input
                        matInput
                        placeholder="Enter Incubator Email ID"
                        formControlName="email"
                        readonly
                        oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                        type="text"
                        (keydown.space)="$event.preventDefault()"
                        [ngClass]="{
                          'is-invalid': add.email.touched && add.email.errors
                        }"
                      />
                      <mat-error *ngIf="add.email.touched && add.email.errors">
                        <span *ngIf="add.email.errors.required"
                          >Email id is required</span
                        >
                        <span *ngIf="add.email.errors.email">
                          <i class="fas fa-exclamation-triangle"></i>
                          Invalid Email
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Phone Number
                        <span class="text-danger">*</span></mat-label
                      >
                      <input
                        matInput
                        type="text"
                        maxlength="10"
                        minlength="10"
                        oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                        placeholder="Enter Phone Number"
                        formControlName="phone"
                        [ngClass]="{
                          'is-invalid': add.phone.touched && add.phone.errors
                        }"
                      />
                      <mat-error *ngIf="add.phone.touched && add.phone.errors">
                        <span *ngIf="add.phone.errors.required"
                          >Phone Number is required</span
                        >
                        <span *ngIf="add.phone.errors.pattern">
                          <i class="fas fa-exclamation-triangle"></i>
                          Phone Number is Invalid
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Year of Establishment
                        <span class="text-danger">*</span></mat-label
                      >
                      <mat-select
                        formControlName="incubatorYearofEstd"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorYearofEstd.touched &&
                            add.incubatorYearofEstd.errors
                        }"
                      >
                        <mat-option
                          *ngFor="let list of yearData"
                          [value]="list"
                        >
                          {{ list }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          add.incubatorYearofEstd.touched &&
                          add.incubatorYearofEstd.errors
                        "
                      >
                        <span *ngIf="add.incubatorYearofEstd.errors.required"
                          >Year of Establishment is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Incubator District
                        <span class="text-danger">*</span></mat-label
                      >
                      <mat-select
                        (selectionChange)="selectIncubator($event.value)"
                        formControlName="incubatorDistrict"
                        #DistrictSelect
                      >
                        <mat-option>
                          <ngx-mat-select-search
                            [formControl]="incubatorDistrictFilterCtrl"
                            placeholderLabel="Search District"
                            noEntriesFoundLabel="District not found"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option
                          *ngFor="
                            let list of incubatorDistrictListValue | async
                          "
                          [value]="list.district"
                        >
                          {{ list.district }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          add.incubatorDistrict.touched &&
                          add.incubatorDistrict.errors
                        "
                      >
                        <span *ngIf="add.incubatorDistrict.errors.required"
                          >Incubator District is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Short Description<span class="text-danger"
                          >*</span
                        ></mat-label
                      >
                      <input
                        matInput
                        placeholder="Enter Short Description"
                        formControlName="incubatorRegDesc"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorRegDesc.touched &&
                            add.incubatorRegDesc.errors
                        }"
                      />
                      <mat-error
                        *ngIf="
                          add.incubatorRegDesc.touched &&
                          add.incubatorRegDesc.errors
                        "
                      >
                        <span *ngIf="add.incubatorRegDesc.errors.required"
                          >Short Description is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="form-rows">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Focused Sector
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Focused Sector"
                                formControlName="incubatorFocusedSector"
                                [ngClass]="{
                                  'is-invalid':
                                    add.incubatorFocusedSector.touched &&
                                    add.incubatorFocusedSector.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  add.incubatorFocusedSector.touched &&
                                  add.incubatorFocusedSector.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    add.incubatorFocusedSector.errors.required
                                  "
                                  >Focused sector is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="form-rows">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                ><span class="text-danger">*</span> Area
                                dedicated for the Incubator (in Sq. ft)
                              </mat-label>
                              <input
                                matInput
                                placeholder="Enter Area dedicated for the Incubator"
                                formControlName="incubatorArea"
                                type="text"
                                oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                                [ngClass]="{
                                  'is-invalid':
                                    add.incubatorArea.touched &&
                                    add.incubatorArea.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  add.incubatorArea.touched &&
                                  add.incubatorArea.errors
                                "
                              >
                                <span *ngIf="add.incubatorArea.errors.required"
                                  >Area dedicated for the Incubator is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="form-rows">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Registration Type
                                <span class="text-danger">*</span></mat-label
                              >
                              <mat-select
                                (selectionChange)="
                                  selectRegistrationType($event.value)
                                "
                                formControlName="incubatorRegistrationType"
                                [ngClass]="{
                                  'is-invalid':
                                    add.incubatorRegistrationType.touched &&
                                    add.incubatorRegistrationType.errors
                                }"
                              >
                                <mat-option value="Society">
                                  Society
                                </mat-option>
                                <mat-option value="Section 8 Company">
                                  Section 8 Company
                                </mat-option>
                                <mat-option value="Trust"> Trust </mat-option>
                                <mat-option value="Other"> Other </mat-option>
                              </mat-select>
                              <mat-error
                                *ngIf="
                                  add.incubatorRegistrationType.touched &&
                                  add.incubatorRegistrationType.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    add.incubatorRegistrationType.errors
                                      .required
                                  "
                                  >Registration Type is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div
                          class="col-lg-6 col-md-6 col-sm-6 col-12"
                          *ngIf="showOtherRegType == true"
                        >
                          <div class="form-rows">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Registration Other Type Details
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Registration Other Type Details"
                                formControlName="incubatorRegistrationTypeOther"
                                [ngClass]="{
                                  'is-invalid':
                                    add.incubatorRegistrationTypeOther
                                      .touched &&
                                    add.incubatorRegistrationTypeOther.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  add.incubatorRegistrationTypeOther.touched &&
                                  add.incubatorRegistrationTypeOther.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    add.incubatorRegistrationTypeOther.errors
                                      .required
                                  "
                                  >Registration Other Type Details is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-md-12 col-12">
                      <div class="form-rows">
                        <mat-label
                          >Registration document
                          <span class="text-danger">*</span></mat-label
                        >
                        <label
                          *ngIf="RegdisName != '✔ Uploaded'"
                          for="input-file-ids"
                          class="md-button md-raised md-primary"
                        >
                          Choose File
                          <ion-icon
                            class="ml-3"
                            name="cloud-upload-outline"
                          ></ion-icon>
                          <span class="ml-3">{{ RegdisName }}</span>
                          <input
                            class="d-none"
                            id="input-file-ids"
                            type="file"
                            (change)="fileRegUpload($event)"
                          />
                        </label>
                        <label
                          *ngIf="RegdisName == '✔ Uploaded'"
                          for="input-file-ids"
                          class="md-button md-raised md-accent"
                        >
                          Update File
                          <ion-icon
                            class="ml-3"
                            name="cloud-upload-outline"
                          ></ion-icon>
                          <span class="ml-3">{{ RegdisName }}</span>
                          <input
                            class="d-none"
                            id="input-file-ids"
                            type="file"
                            (change)="fileRegUpload($event)"
                          />
                        </label>
                        <div class="text-center">
                          <span class="noti-span"
                            >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                            file size: 10mb)</span
                          >
                        </div>
                        <mat-error
                          class="font-12"
                          *ngIf="
                            add.incubatorRegFileName.touched &&
                            add.incubatorRegFileName.errors
                          "
                        >
                          <span *ngIf="add.incubatorRegFileName.errors.required"
                            >Document is required</span
                          >
                        </mat-error>
                        <div
                          class="text-center mt-2 mb-3"
                          *ngIf="RegdisName == '✔ Uploaded'"
                        >
                          <a
                            class="pdf-btn"
                            href="{{ proFile.incubatorRegFileName }}"
                            target="_blank"
                            >View Document</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-12" class="tab-view">
              <div class="text-center p-relative">
                <div class="circle">
                  <img class="profile-pic" [src]="image_urls" />
                </div>
                <div class="p-image">
                  <label for="files"
                    ><i class="fa fa-camera upload-button"></i
                  ></label>
                  <input
                    class="file-upload"
                    (change)="onSelectImage($event)"
                    id="files"
                    type="file"
                    accept="image/*"
                  />
                </div>
                <p class="logo-span">Logo <span class="text-danger">*</span></p>
                <p>
                  <span class="noti-span"
                    >(Supported Format: png,jpg,jpeg) <br />(Max file size:
                    10mb) <br />
                    (Suggested Image Dimensions: 160 x 160)</span
                  >
                </p>
                <p
                  *ngIf="
                    logoCheck &&
                    selecetdImage &&
                    selecetdImage.size / (1024 * 1024) > maxSizeMB
                  "
                  class="text-danger"
                >
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <p *ngIf="logoCheck && !selecetdImage" class="text-danger">
                  Logo is required
                </p>
              </div>
            </div>
          </div>
          <p class="sub-title">
            Facilities Available <span class="text-danger">*</span>
          </p>
          <div class="row mb-3">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="form-rows">
                <mat-checkbox
                  class="example-margin"
                  formControlName="coworkingSpace"
                  (change)="checkFacilities($event.checked, 'Co-working space')"
                >
                  Co-working space</mat-checkbox
                >
                <mat-checkbox
                  class="example-margin"
                  formControlName="fablabMakerSpace"
                  (change)="
                    checkFacilities($event.checked, 'Fablab/MakerSpace')
                  "
                >
                  Fablab/MakerSpace</mat-checkbox
                >
                <mat-checkbox
                  class="example-margin"
                  formControlName="focusSectorLaboratories"
                  (change)="
                    checkFacilities($event.checked, 'Focus Sector Laboratories')
                  "
                >
                  Focus Sector Laboratories</mat-checkbox
                >
                <mat-checkbox
                  class="example-margin"
                  formControlName="salesKioskIncubatees"
                  (change)="
                    checkFacilities(
                      $event.checked,
                      'Sales Kiosk for Incubatees'
                    )
                  "
                >
                  Sales Kiosk for Incubatees</mat-checkbox
                >
                <mat-checkbox
                  class="example-margin"
                  formControlName="trainingSeminarHall"
                  (change)="
                    checkFacilities($event.checked, 'Training/Seminar Hall')
                  "
                >
                  Training/Seminar Hall</mat-checkbox
                >
                <mat-error
                  *ngIf="
                    add.incubatorFacilities.touched &&
                    add.incubatorFacilities.errors
                  "
                >
                  <span *ngIf="add.incubatorFacilities.errors.required"
                    >Incubator Facilities is required</span
                  >
                </mat-error>
              </div>
            </div>
          </div>
          <p class="sub-title">Incubator Team Details</p>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="row">
                <div class="col-4">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Title <span class="text-danger">*</span></mat-label
                      >
                      <mat-select
                        formControlName="incubatorTeamNameTitle"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorTeamNameTitle.touched &&
                            add.incubatorTeamNameTitle.errors
                        }"
                      >
                        <mat-option value="Mr."> Mr. </mat-option>
                        <mat-option value="Mrs."> Mrs. </mat-option>
                        <mat-option value="Ms."> Ms. </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          add.incubatorTeamNameTitle.touched &&
                          add.incubatorTeamNameTitle.errors
                        "
                      >
                        <span *ngIf="add.incubatorTeamNameTitle.errors.required"
                          >Title is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-8 col-md-4 col-sm-6 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >First Name
                        <span class="text-danger">*</span></mat-label
                      >
                      <input
                        matInput
                        placeholder="Enter First Name"
                        formControlName="incubatorTeamFirstName"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorTeamFirstName.touched &&
                            add.incubatorTeamFirstName.errors
                        }"
                      />
                      <mat-error
                        *ngIf="
                          add.incubatorTeamFirstName.touched &&
                          add.incubatorTeamFirstName.errors
                        "
                      >
                        <span *ngIf="add.incubatorTeamFirstName.errors.required"
                          >First Name is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Last Name <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name"
                    formControlName="incubatorTeamLastName"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamLastName.touched &&
                        add.incubatorTeamLastName.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamLastName.touched &&
                      add.incubatorTeamLastName.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamLastName.errors.required"
                      >Last Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Designation <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Designation"
                    formControlName="incubatorTeamDesignation"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamDesignation.touched &&
                        add.incubatorTeamDesignation.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamDesignation.touched &&
                      add.incubatorTeamDesignation.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamDesignation.errors.required"
                      >Designation is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >CEO/Manager LinkedIn Profile
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter CEO/Manager LinkedIn Profile"
                    formControlName="incubatorTeamLinkedin"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamLinkedin.touched &&
                        add.incubatorTeamLinkedin.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamLinkedin.touched &&
                      add.incubatorTeamLinkedin.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamLinkedin.errors.required"
                      >CEO/Manager LinkedIn Profile is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Contact <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    maxlength="10"
                    minlength="10"
                    oninput="this.value = this.value.replace(/[^0-9,-]/g,'')"
                    placeholder="Enter contact"
                    formControlName="incubatorTeamPhone"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamPhone.touched &&
                        add.incubatorTeamPhone.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamPhone.touched &&
                      add.incubatorTeamPhone.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamPhone.errors.required"
                      >Contact is required</span
                    >
                    <span *ngIf="add.incubatorTeamPhone.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Contact Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Email id <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter email id"
                    formControlName="incubatorTeamEmail"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamEmail.touched &&
                        add.incubatorTeamEmail.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamEmail.touched &&
                      add.incubatorTeamEmail.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamEmail.errors.required"
                      >Email id is required</span
                    >
                    <span *ngIf="add.incubatorTeamEmail.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Size of Operations Team
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Size of Operations Team"
                    formControlName="incubatorTeamSize"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamSize.touched &&
                        add.incubatorTeamSize.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamSize.touched &&
                      add.incubatorTeamSize.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamSize.errors.required"
                      >Size of Operations Team is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger">*</span> No. of additional
                    manpower from Projects/Scheme operated by the incubator
                  </mat-label>
                  <input
                    matInput
                    placeholder="Enter additional manpower details"
                    formControlName="incubatorTeamAddlManpower"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTeamAddlManpower.touched &&
                        add.incubatorTeamAddlManpower.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTeamAddlManpower.touched &&
                      add.incubatorTeamAddlManpower.errors
                    "
                  >
                    <span *ngIf="add.incubatorTeamAddlManpower.errors.required"
                      >Additional manpower details is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <p class="sub-title">Host Institution</p>
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Institution Name
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Institution Name"
                    formControlName="incubatorHostInstitution"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorHostInstitution.touched &&
                        add.incubatorHostInstitution.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorHostInstitution.touched &&
                      add.incubatorHostInstitution.errors
                    "
                  >
                    <span *ngIf="add.incubatorHostInstitution.errors.required"
                      >Institution Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Institution Phone Number
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    maxlength="10"
                    minlength="10"
                    oninput="this.value = this.value.replace(/[^0-9,-]/g,'')"
                    placeholder="Enter Institution Phone Number"
                    formControlName="incubatorHostPhone"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorHostPhone.touched &&
                        add.incubatorHostPhone.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorHostPhone.touched &&
                      add.incubatorHostPhone.errors
                    "
                  >
                    <span *ngIf="add.incubatorHostPhone.errors.required"
                      >Institution phone number is required</span
                    >
                    <span *ngIf="add.incubatorHostPhone.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Phone Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Institution Email ID
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Institution Email ID "
                    formControlName="incubatorHostEmail"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorHostEmail.touched &&
                        add.incubatorHostEmail.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorHostEmail.touched &&
                      add.incubatorHostEmail.errors
                    "
                  >
                    <span *ngIf="add.incubatorHostEmail.errors.required"
                      >Institution Email ID is required</span
                    >
                    <span *ngIf="add.incubatorHostEmail.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Registered Address Line 1<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Registered Address Line 1"
                    formControlName="incubatorRegAddressLine1"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegAddressLine1.touched &&
                        add.incubatorRegAddressLine1.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegAddressLine1.touched &&
                      add.incubatorRegAddressLine1.errors
                    "
                  >
                    <span *ngIf="add.incubatorRegAddressLine1.errors.required"
                      >Registered Address Line 1 is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Registered Address Line 2<span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Registered Address Line 2"
                    formControlName="incubatorRegAddressLine2"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegAddressLine2.touched &&
                        add.incubatorRegAddressLine2.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegAddressLine2.touched &&
                      add.incubatorRegAddressLine2.errors
                    "
                  >
                    <span *ngIf="add.incubatorRegAddressLine2.errors.required"
                      >Registered Address Line 2 is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Registered City<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Registered City"
                    formControlName="incubatorRegCity"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegCity.touched &&
                        add.incubatorRegCity.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegCity.touched &&
                      add.incubatorRegCity.errors
                    "
                  >
                    <span *ngIf="add.incubatorRegCity.errors.required"
                      >Registered City is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Registered State<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Registered State"
                    formControlName="incubatorRegState"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegState.touched &&
                        add.incubatorRegState.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegState.touched &&
                      add.incubatorRegState.errors
                    "
                  >
                    <span *ngIf="add.incubatorRegState.errors.required"
                      >Registered State is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Registered Zipcode<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Registered Zipcode"
                    formControlName="incubatorRegZipcode"
                    type="text"
                    maxlength="6"
                    minlength="6"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorRegZipcode.touched &&
                        add.incubatorRegZipcode.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorRegZipcode.touched &&
                      add.incubatorRegZipcode.errors
                    "
                  >
                    <span *ngIf="add.incubatorRegZipcode.errors.required"
                      >Registered Zipcode is required</span
                    >
                    <span *ngIf="add.incubatorRegZipcode.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Zipcode
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-row">
                <mat-checkbox
                  class="example-margin"
                  formControlName="operationalAddressFlag"
                  value="Co-working space"
                  (change)="showOperationalAddress($event)"
                >
                </mat-checkbox>
                Operations Address (Mention, If not same as above)
              </div>
            </div>
          </div>
          <div class="row" *ngIf="operationalAdd == true">
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Operations Address Line 1
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Operational Address Line 1"
                    formControlName="incubatorOprAddressLine1"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorOprAddressLine1.touched &&
                        add.incubatorOprAddressLine1.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorOprAddressLine1.touched &&
                      add.incubatorOprAddressLine1.errors
                    "
                  >
                    <span *ngIf="add.incubatorOprAddressLine1.errors.required"
                      >Operations Address Line 1 is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Operations Address Line 2 <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Operational Address Line 2"
                    formControlName="incubatorOprAddressLine2"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorOprAddressLine2.touched &&
                        add.incubatorOprAddressLine2.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorOprAddressLine2.touched &&
                      add.incubatorOprAddressLine2.errors
                    "
                  >
                    <span *ngIf="add.incubatorOprAddressLine2.errors.required"
                      >Operations Address Line 2 is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Operations City
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Operations City"
                    formControlName="incubatorOprCity"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorOprCity.touched &&
                        add.incubatorOprCity.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorOprCity.touched &&
                      add.incubatorOprCity.errors
                    "
                  >
                    <span *ngIf="add.incubatorOprCity.errors.required"
                      >Operations City is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Operations State
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Operations State"
                    formControlName="incubatorOprState"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorOprState.touched &&
                        add.incubatorOprState.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorOprState.touched &&
                      add.incubatorOprState.errors
                    "
                  >
                    <span *ngIf="add.incubatorOprState.errors.required"
                      >Operations State is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Operations Zipcode
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Operations Zipcode"
                    formControlName="incubatorOprZipcode"
                    type="text"
                    maxlength="6"
                    minlength="6"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorOprZipcode.touched &&
                        add.incubatorOprZipcode.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorOprZipcode.touched &&
                      add.incubatorOprZipcode.errors
                    "
                  >
                    <span *ngIf="add.incubatorOprZipcode.errors.required"
                      >Operations Zipcode is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <p class="sub-title">Sponsorship</p>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <div
                class="table-details table-responsive"
                formGroupName="incubatorSponsorship"
              >
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Sponsorship Agency Type</th>
                      <th>Name of the Sponsor</th>
                      <th>Sponsorship Agency Other Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let item of SponsorshipList.controls;
                        let i = index
                      "
                      [formGroup]="item"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <select
                          class="form-control"
                          formControlName="incubatorSponsorshipAgencyType"
                          (change)="
                            checkSponsorshipType($event.target.value, i)
                          "
                          [ngClass]="{
                            'is-invalid':
                              item.controls.incubatorSponsorshipAgencyType
                                .touched &&
                              item.controls.incubatorSponsorshipAgencyType
                                .errors
                          }"
                        >
                          <option value="" selected disabled>
                            --Sponsorship Agency Type--
                          </option>
                          <option value="Government">Government</option>
                          <option value="Private">Private</option>
                          <option value="Other">Other</option>
                        </select>
                        <div
                          *ngIf="
                            item.controls.incubatorSponsorshipAgencyType
                              .touched &&
                            item.controls.incubatorSponsorshipAgencyType.errors
                          "
                        >
                          <span
                            class="text-danger"
                            *ngIf="
                              item.controls.incubatorSponsorshipAgencyType
                                .errors.required
                            "
                          >
                            Sponsorship Agency Type is required
                          </span>
                        </div>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          formControlName="incubatorSponsorshipAgencyName"
                          [ngClass]="{
                            'is-invalid':
                              item.controls.incubatorSponsorshipAgencyName
                                .touched &&
                              item.controls.incubatorSponsorshipAgencyName
                                .errors
                          }"
                          type="text"
                          placeholder="Name of the Sponsor"
                        />
                        <div
                          *ngIf="
                            item.controls.incubatorSponsorshipAgencyName
                              .touched &&
                            item.controls.incubatorSponsorshipAgencyName.errors
                          "
                        >
                          <span
                            class="text-danger"
                            *ngIf="
                              item.controls.incubatorSponsorshipAgencyName
                                .errors.required
                            "
                          >
                            Name of the Sponsor is required
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="agency Sponsorship{{ i }}">
                          <input
                            class="form-control"
                            formControlName="incubatorSponsorshipAgencyTypeOther"
                            [ngClass]="{
                              'is-invalid':
                                item.controls
                                  .incubatorSponsorshipAgencyTypeOther
                                  .touched &&
                                item.controls
                                  .incubatorSponsorshipAgencyTypeOther.errors
                            }"
                            type="text"
                            placeholder="Sponsorship Agency Other Type"
                          />
                          <div
                            *ngIf="
                              item.controls.incubatorSponsorshipAgencyTypeOther
                                .touched &&
                              item.controls.incubatorSponsorshipAgencyTypeOther
                                .errors
                            "
                          >
                            <span
                              class="text-danger"
                              *ngIf="
                                item.controls
                                  .incubatorSponsorshipAgencyTypeOther.errors
                                  .required
                              "
                            >
                              Sponsorship Agency Other Type
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <ion-icon
                          *ngIf="
                            item.controls.incubatorSponsorshipAgencyType
                              .value ||
                            item.controls.incubatorSponsorshipAgencyName
                              .value ||
                            item.controls.incubatorSponsorshipAgencyTypeOther
                              .value
                          "
                          class="set-add-btn"
                          name="add-circle-outline"
                          (click)="addSponsorshipRow(i)"
                        ></ion-icon>
                        <ion-icon
                          class="set-delete-btn"
                          name="close-circle-outline"
                          (click)="
                            deleteSponsorshipRow(i, item.controls.id.value)
                          "
                        ></ion-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <p class="sub-title">Branch</p>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                  <mat-label class="">
                    Do you have Branch?
                    <span class="text-danger">*</span></mat-label
                  >
                  <br />
                  <mat-radio-group
                    class="example-margin mt-4"
                    aria-label="Select an option"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorBranchAvail.touched &&
                        add.incubatorBranchAvail.errors
                    }"
                    (change)="showBranchOptions($event.value)"
                    formControlName="incubatorBranchAvail"
                  >
                    <mat-radio-button value="Yes">Yes</mat-radio-button>
                    <mat-radio-button value="No">No</mat-radio-button>
                    <mat-error
                      *ngIf="
                        add.incubatorBranchAvail.touched &&
                        add.incubatorBranchAvail.errors
                      "
                    >
                      <span *ngIf="add.incubatorBranchAvail.errors.required"
                        >Branch Details is required</span
                      >
                    </mat-error>
                  </mat-radio-group>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-12 col-12"
                  *ngIf="Branchchecked == 'Yes'"
                >
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label>
                        Branch details
                        <span class="text-danger">*</span></mat-label
                      >
                      <input
                        matInput
                        placeholder="Enter Branch details"
                        formControlName="incubatorBranch"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorBranch.touched &&
                            add.incubatorBranch.errors
                        }"
                      />
                      <mat-error
                        *ngIf="
                          add.incubatorBranch.touched &&
                          add.incubatorBranch.errors
                        "
                      >
                        <span *ngIf="add.incubatorBranch.errors.required"
                          >Branch details is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <p class="sub-title">Mentoring</p>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                  <mat-label class="mb-4">
                    Mentor programmes
                    <span class="text-danger">*</span></mat-label
                  >
                  <br />
                  <mat-radio-group
                    class="example-margin"
                    aria-label="Select an option"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorMentorProgAvail.touched &&
                        add.incubatorMentorProgAvail.errors
                    }"
                    (change)="showMentoringOptions($event.value)"
                    formControlName="incubatorMentorProgAvail"
                  >
                    <mat-radio-button value="Yes">Yes</mat-radio-button>
                    <mat-radio-button value="No">No</mat-radio-button>
                    <mat-error
                      *ngIf="
                        add.incubatorMentorProgAvail.touched &&
                        add.incubatorMentorProgAvail.errors
                      "
                    >
                      <span *ngIf="add.incubatorMentorProgAvail.errors.required"
                        >Mentor programmes is required</span
                      >
                    </mat-error>
                  </mat-radio-group>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-12 col-12"
                  *ngIf="Mentorchecked == 'Yes'"
                >
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >No of Registered Mentors
                        <span class="text-danger">*</span></mat-label
                      >
                      <input
                        type="text"
                        matInput
                        placeholder="Enter No of Registered Mentors "
                        formControlName="incubatorMentorReg"
                        type="text"
                        oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorMentorReg.touched &&
                            add.incubatorMentorReg.errors
                        }"
                      />
                      <mat-error
                        *ngIf="
                          add.incubatorMentorReg.touched &&
                          add.incubatorMentorReg.errors
                        "
                      >
                        <span *ngIf="add.incubatorMentorReg.errors.required"
                          >No of Registered Mentors is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="sub-title">Social Media</p>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Website <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Website URL"
                    formControlName="incubatorWebsite"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorWebsite.touched &&
                        add.incubatorWebsite.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorWebsite.touched &&
                      add.incubatorWebsite.errors
                    "
                  >
                    <span *ngIf="add.incubatorWebsite.errors.required"
                      >Website is required</span
                    >
                    <span *ngIf="add.incubatorWebsite.errors.url"
                      >Please enter proper url format</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >LinkedIn Official Handle <span class="text-danger"></span
                  ></mat-label>
                  <input
                    type="text"
                    matInput
                    placeholder="Enter LinkedIn URL"
                    formControlName="incubatorLinkedin"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorLinkedin.touched &&
                        add.incubatorLinkedin.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorLinkedin.touched &&
                      add.incubatorLinkedin.errors
                    "
                  >
                    <span *ngIf="add.incubatorLinkedin.errors.required"
                      >LinkedIn is required</span
                    >
                    <span *ngIf="add.incubatorLinkedin.errors.url"
                      >Please enter proper url format</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Facebook Official Handle <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Facebook URL"
                    formControlName="incubatorFacebook"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorFacebook.touched &&
                        add.incubatorFacebook.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorFacebook.touched &&
                      add.incubatorFacebook.errors
                    "
                  >
                    <span *ngIf="add.incubatorFacebook.errors.required"
                      >Facebook URL is required</span
                    >
                    <span *ngIf="add.incubatorFacebook.errors.url"
                      >Please enter proper url format</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Twitter Official Handle <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Twitter URL"
                    formControlName="incubatorTwitter"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorTwitter.touched &&
                        add.incubatorTwitter.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorTwitter.touched &&
                      add.incubatorTwitter.errors
                    "
                  >
                    <span *ngIf="add.incubatorTwitter.errors.required"
                      >Twitter URL is required</span
                    >
                    <span *ngIf="add.incubatorTwitter.errors.url"
                      >Please enter proper url format</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Instagram Official Handle <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Instagram URL"
                    formControlName="incubatorInstagram"
                    [ngClass]="{
                      'is-invalid':
                        add.incubatorInstagram.touched &&
                        add.incubatorInstagram.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubatorInstagram.touched &&
                      add.incubatorInstagram.errors
                    "
                  >
                    <span *ngIf="add.incubatorInstagram.errors.required"
                      >Instagram URL is required</span
                    >
                    <span *ngIf="add.incubatorInstagram.errors.url"
                      >Please enter proper url format</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <p class="sub-title">Incubator Other Details</p>
          <div class="row">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div class="form-rows mb-2">
                    <mat-label class="">
                      Do you have IP Policy?
                      <span class="text-danger">*</span></mat-label
                    >
                    <br />
                    <mat-radio-group
                      class="example-margin"
                      aria-label="Select an option"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorHasIpPolicy.touched &&
                          add.incubatorHasIpPolicy.errors
                      }"
                      formControlName="incubatorHasIpPolicy"
                    >
                      <mat-radio-button value="Yes">Yes</mat-radio-button>
                      <mat-radio-button value="No">No</mat-radio-button>
                      <mat-error
                        *ngIf="
                          add.incubatorHasIpPolicy.touched &&
                          add.incubatorHasIpPolicy.errors
                        "
                      >
                        <span *ngIf="add.incubatorHasIpPolicy.errors.required"
                          >IP Policy is required</span
                        >
                      </mat-error>
                    </mat-radio-group>
                  </div>
                  <div class="form-rows mb-2">
                    <mat-label class="">
                      Do you offer Pre-Incubation Program?
                      <span class="text-danger">*</span></mat-label
                    >
                    <br />
                    <mat-radio-group
                      class="example-margin"
                      aria-label="Select an option"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorOfferPreIncProg.touched &&
                          add.incubatorOfferPreIncProg.errors
                      }"
                      formControlName="incubatorOfferPreIncProg"
                    >
                      <mat-radio-button value="Yes">Yes</mat-radio-button>
                      <mat-radio-button value="No">No</mat-radio-button>
                      <mat-error
                        *ngIf="
                          add.incubatorOfferPreIncProg.touched &&
                          add.incubatorOfferPreIncProg.errors
                        "
                      >
                        <span
                          *ngIf="add.incubatorOfferPreIncProg.errors.required"
                          >Offer Pre-Incubation Program is required</span
                        >
                      </mat-error>
                    </mat-radio-group>
                  </div>
                  <div class="form-rows mb-2">
                    <mat-label class="">
                      Do you have Student Startup Policy?
                      <span class="text-danger">*</span></mat-label
                    >
                    <br />
                    <mat-radio-group
                      class="example-margin"
                      aria-label="Select an option"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorHasStudStartupPol.touched &&
                          add.incubatorHasStudStartupPol.errors
                      }"
                      formControlName="incubatorHasStudStartupPol"
                    >
                      <mat-radio-button value="Yes">Yes</mat-radio-button>
                      <mat-radio-button value="No">No</mat-radio-button>
                      <mat-error
                        *ngIf="
                          add.incubatorHasStudStartupPol.touched &&
                          add.incubatorHasStudStartupPol.errors
                        "
                      >
                        <span
                          *ngIf="add.incubatorHasStudStartupPol.errors.required"
                          >Student Startup Policy is required</span
                        >
                      </mat-error>
                    </mat-radio-group>
                  </div>
                  <div class="form-rows mb-2">
                    <mat-label class="">
                      Do you have Technology Transfer Office?
                      <span class="text-danger">*</span></mat-label
                    >
                    <br />
                    <mat-radio-group
                      class="example-margin"
                      aria-label="Select an option"
                      [ngClass]="{
                        'is-invalid':
                          add.incubatorHasTechTransPol.touched &&
                          add.incubatorHasTechTransPol.errors
                      }"
                      formControlName="incubatorHasTechTransPol"
                    >
                      <mat-radio-button value="Yes">Yes</mat-radio-button>
                      <mat-radio-button value="No">No</mat-radio-button>
                      <mat-error
                        *ngIf="
                          add.incubatorHasTechTransPol.touched &&
                          add.incubatorHasTechTransPol.errors
                        "
                      >
                        <span
                          *ngIf="add.incubatorHasTechTransPol.errors.required"
                          >Technology Transfer Office is required</span
                        >
                      </mat-error>
                    </mat-radio-group>
                  </div>
                  <div class="form-rows mb-2">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        >Google Map <span class="text-danger"></span
                      ></mat-label>
                      <mat-icon
                        matSuffix
                        (click)="openDialog()"
                        class="c-pointer"
                      >
                        not_listed_location</mat-icon
                      >
                      <input
                        matInput
                        placeholder="Enter Google Map"
                        formControlName="googleMap"
                        (input)="googleMapCheck($event)"
                        [ngClass]="{
                          'is-invalid':
                            add.googleMap.touched && add.googleMap.errors
                        }"
                      />
                    </mat-form-field>
                    <span
                      class="text-danger font-12"
                      *ngIf="googleCheck == true"
                      >Please enter proper Google Map Path</span
                    >
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div class="form-rows">
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        ><span class="text-danger">*</span> Please list down all
                        schemes provided by Incubators for Incubatees
                      </mat-label>
                      <textarea
                        matInput
                        placeholder="Enter Incubatees Schemes"
                        formControlName="incubatorProvidedSchemes"
                        cols="30"
                        rows="6"
                        [ngClass]="{
                          'is-invalid':
                            add.incubatorProvidedSchemes.touched &&
                            add.incubatorProvidedSchemes.errors
                        }"
                      ></textarea>
                      <mat-error
                        *ngIf="
                          add.incubatorProvidedSchemes.touched &&
                          add.incubatorProvidedSchemes.errors
                        "
                      >
                        <span
                          *ngIf="add.incubatorProvidedSchemes.errors.required"
                          >Incubatees Schemes is required</span
                        >
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field
                      class="material-full-width"
                      appearance="outline"
                    >
                      <mat-label
                        ><span class="text-danger">*</span> Special accolades /
                        awards / recognitions received by the Incubator
                      </mat-label>
                      <textarea
                        matInput
                        placeholder="Enter Special accolades / awards / recognitions Details"
                        formControlName="specialReceivedIncubator"
                        cols="30"
                        rows="5"
                        [ngClass]="{
                          'is-invalid':
                            add.specialReceivedIncubator.touched &&
                            add.specialReceivedIncubator.errors
                        }"
                      ></textarea>
                      <mat-error
                        *ngIf="
                          add.specialReceivedIncubator.touched &&
                          add.specialReceivedIncubator.errors
                        "
                      >
                        <span
                          *ngIf="add.specialReceivedIncubator.errors.required"
                          >Special accolades / awards / recognitions Details is
                          required</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-12">
              <div class="form-rows mb-2">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Youtube Video Link <span class="text-danger"></span
                  ></mat-label>
                  <mat-icon
                    matSuffix
                    (click)="openYoutubeDialog()"
                    class="c-pointer"
                  >
                    help</mat-icon
                  >
                  <input
                    matInput
                    placeholder="Enter Youtube Video Link"
                    formControlName="youtubeVideoLink"
                    [ngClass]="{
                      'is-invalid':
                        add.youtubeVideoLink.touched &&
                        add.youtubeVideoLink.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.youtubeVideoLink.touched &&
                      add.youtubeVideoLink.errors
                    "
                  >
                    <span *ngIf="add.youtubeVideoLink.errors.required"
                      >Youtube Video Link is required</span
                    >
                    <span *ngIf="add.youtubeVideoLink.errors.url"
                      >Please enter proper url format</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-rows mt-3">
                <mat-label
                  >Please upload your Incubator Brochure
                  <span class="text-danger"></span
                ></mat-label>
                <label
                  *ngIf="disName != '✔ Uploaded'"
                  for="input-file-id"
                  class="md-button md-raised md-primary"
                >
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id"
                    type="file"
                    (change)="fileUpload($event)"
                  />
                </label>
                <label
                  *ngIf="disName == '✔ Uploaded'"
                  for="input-file-id"
                  class="md-button md-raised md-accent"
                >
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id"
                    type="file"
                    (change)="fileUpload($event)"
                  />
                </label>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="disName"
                    ><i
                      class="fas fa-trash delete-i"
                      (click)="deleteImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
                <div
                  class="text-center mt-2 mb-3"
                  *ngIf="disName == '✔ Uploaded'"
                >
                  <a
                    class="pdf-btn"
                    href="{{ proFile.incubatorBrouchureName }}"
                    target="_blank"
                    >View Brochure</a
                  >
                </div>
              </div>
            </div>
          </div>
          <p class="sub-title">Funding Support</p>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <div
                class="table-details table-responsive"
                formGroupName="incubatorFunding"
              >
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Funding Agency Type</th>
                      <th>Name of the Funding Agency</th>
                      <th>Funding Agency Other Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of fundingList.controls; let i = index"
                      [formGroup]="item"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <select
                          class="form-control"
                          formControlName="incubatorFundingAgencyType"
                          (change)="checkAgencyType($event.target.value, i)"
                          [ngClass]="{
                            'is-invalid':
                              item.controls.incubatorFundingAgencyType
                                .touched &&
                              item.controls.incubatorFundingAgencyType.errors
                          }"
                        >
                          <option value="" selected disabled>
                            --Funding Agency Type--
                          </option>
                          <option value="NIDHI-PRAYAS">NIDHI-PRAYAS</option>
                          <option value="NIDHI-Seed Support Scheme">
                            NIDHI-Seed Support Scheme
                          </option>
                          <option value="TDB - Seed Support Scheme">
                            TDB - Seed Support Scheme
                          </option>
                          <option value="BIRAC - Seed Fund">
                            BIRAC - Seed Fund
                          </option>
                          <option value="Startup India Seed Fund Scheme">
                            Startup India Seed Fund Scheme
                          </option>
                          <option value="RKVY-RAFTAAR AOP">
                            RKVY-RAFTAAR AOP
                          </option>
                          <option value="RKVY-RAFTAAR SAIP">
                            RKVY-RAFTAAR SAIP
                          </option>
                          <option value="Other">Other</option>
                        </select>
                        <div
                          *ngIf="
                            item.controls.incubatorFundingAgencyType.touched &&
                            item.controls.incubatorFundingAgencyType.errors
                          "
                        >
                          <span
                            class="text-danger"
                            *ngIf="
                              item.controls.incubatorFundingAgencyType.errors
                                .required
                            "
                          >
                            Funding Agency Type is required
                          </span>
                        </div>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          formControlName="incubatorFundingAgencyName"
                          [ngClass]="{
                            'is-invalid':
                              item.controls.incubatorFundingAgencyName
                                .touched &&
                              item.controls.incubatorFundingAgencyName.errors
                          }"
                          type="text"
                          placeholder="Name of the Funding Agency"
                        />
                        <div
                          *ngIf="
                            item.controls.incubatorFundingAgencyName.touched &&
                            item.controls.incubatorFundingAgencyName.errors
                          "
                        >
                          <span
                            class="text-danger"
                            *ngIf="
                              item.controls.incubatorFundingAgencyName.errors
                                .required
                            "
                          >
                            Name of the Funding Agency is required
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="agency agencyType{{ i }}">
                          <input
                            class="form-control"
                            formControlName="incubatorFundingAgencyTypeOther"
                            [ngClass]="{
                              'is-invalid':
                                item.controls.incubatorFundingAgencyTypeOther
                                  .touched &&
                                item.controls.incubatorFundingAgencyTypeOther
                                  .errors
                            }"
                            type="text"
                            placeholder="Funding Agency Other Type"
                          />
                          <div
                            *ngIf="
                              item.controls.incubatorFundingAgencyTypeOther
                                .touched &&
                              item.controls.incubatorFundingAgencyTypeOther
                                .errors
                            "
                          >
                            <span
                              class="text-danger"
                              *ngIf="
                                item.controls.incubatorFundingAgencyTypeOther
                                  .errors.required
                              "
                            >
                              Funding Agency Other Type is required
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <ion-icon
                          *ngIf="
                            item.controls.incubatorFundingAgencyType.value ||
                            item.controls.incubatorFundingAgencyName.value ||
                            item.controls.incubatorFundingAgencyTypeOther.value
                          "
                          class="set-add-btn"
                          name="add-circle-outline"
                          (click)="addRow(i)"
                        ></ion-icon>
                        <ion-icon
                          class="set-delete-btn"
                          name="close-circle-outline"
                          (click)="deleteRow(i, item.controls.id.value)"
                        ></ion-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <p class="sub-title">Incubatee Details</p>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger">*</span> Total number of
                    Incubatees?
                  </mat-label>
                  <input
                    matInput
                    placeholder="Enter number of Incubatees"
                    formControlName="incubateesCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesCount.touched &&
                        add.incubateesCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesCount.touched && add.incubateesCount.errors
                    "
                  >
                    <span *ngIf="add.incubateesCount.errors.required"
                      >Number of Incubatees is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger">*</span> Total no. of DPIIT
                    recognized Startup(s)/incubatee(s)
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    placeholder="Enter Incubatees DPIIT Recog Count"
                    formControlName="incubateesDPIITRecogCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesDPIITRecogCount.touched &&
                        add.incubateesDPIITRecogCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesDPIITRecogCount.touched &&
                      add.incubateesDPIITRecogCount.errors
                    "
                  >
                    <span *ngIf="add.incubateesDPIITRecogCount.errors.required"
                      >Incubatees DPIIT Recog Count is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger"></span> Total no. of SC/ST
                    founder incubatee(s)
                  </mat-label>
                  <input
                    matInput
                    placeholder="Enter SC/ST Founders Count"
                    formControlName="incubateesSCSTFoundersCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesSCSTFoundersCount.touched &&
                        add.incubateesSCSTFoundersCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesSCSTFoundersCount.touched &&
                      add.incubateesSCSTFoundersCount.errors
                    "
                  >
                    <span
                      *ngIf="add.incubateesSCSTFoundersCount.errors.required"
                      >SC/ST Founders Count is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger">*</span> No of Incubatees who
                    currently availing physical space
                  </mat-label>
                  <input
                    matInput
                    placeholder="Enter Incubatees Physical Space Count"
                    formControlName="incubateesPhysicalSpaceCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesPhysicalSpaceCount.touched &&
                        add.incubateesPhysicalSpaceCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesPhysicalSpaceCount.touched &&
                      add.incubateesPhysicalSpaceCount.errors
                    "
                  >
                    <span
                      *ngIf="add.incubateesPhysicalSpaceCount.errors.required"
                      >Incubatees Physical Space Count is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger">*</span> No of Incubatees who
                    currently availing support through Virtual mode
                  </mat-label>
                  <input
                    matInput
                    placeholder="Enter Incubatees Virtual Space Count"
                    formControlName="incubateesVirtualSpaceCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesVirtualSpaceCount.touched &&
                        add.incubateesVirtualSpaceCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesVirtualSpaceCount.touched &&
                      add.incubateesVirtualSpaceCount.errors
                    "
                  >
                    <span
                      *ngIf="add.incubateesVirtualSpaceCount.errors.required"
                      >Incubatees Virtual Space Count is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Total no. of Women founder incubatee(s)
                    <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Number of Women founder incubatee(s) "
                    formControlName="incubateesWomenFoundersCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesWomenFoundersCount.touched &&
                        add.incubateesWomenFoundersCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesWomenFoundersCount.touched &&
                      add.incubateesWomenFoundersCount.errors
                    "
                  >
                    <span
                      *ngIf="add.incubateesWomenFoundersCount.errors.required"
                      >Number of Women founder incubatee(s) is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Number of Graduated Startup(s)
                    <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Number of Graduated Startup(s)"
                    formControlName="incubateesGraduatedStartupsCount"
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesGraduatedStartupsCount.touched &&
                        add.incubateesGraduatedStartupsCount.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesGraduatedStartupsCount.touched &&
                      add.incubateesGraduatedStartupsCount.errors
                    "
                  >
                    <span
                      *ngIf="
                        add.incubateesGraduatedStartupsCount.errors.required
                      "
                      >Number of Graduated Startup(s) is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Is there anything else you would like us to know about your
                    Incubator? <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter about your Incubator"
                    formControlName="incubateesComments"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesComments.touched &&
                        add.incubateesComments.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesComments.touched &&
                      add.incubateesComments.errors
                    "
                  >
                    <span *ngIf="add.incubateesComments.errors.required"
                      >about your Incubator is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Is there any specific support required from StartupTN?
                    <span class="text-danger"></span
                  ></mat-label>
                  <input
                    matInput
                    placeholder="Enter Incubatees Support Required Comments"
                    formControlName="incubateesSupportRequiredComments"
                    [ngClass]="{
                      'is-invalid':
                        add.incubateesSupportRequiredComments.touched &&
                        add.incubateesSupportRequiredComments.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.incubateesSupportRequiredComments.touched &&
                      add.incubateesSupportRequiredComments.errors
                    "
                  >
                    <span
                      *ngIf="
                        add.incubateesSupportRequiredComments.errors.required
                      "
                      >Incubatees Support Required Comments is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </form>
        <div class="text-center">
          <button
            *ngIf="roleValue == 'Incubator' && proReg == 'Yes'"
            class="mr-2 new-btn-color2"
            mat-raised-button
            color="warn"
            (click)="cancelReg()"
          >
            Cancel
          </button>
          <button
            *ngIf="roleValue == 'Admin'"
            class="mr-2 new-btn-color2"
            mat-raised-button
            color="warn"
            (click)="AdminBack()"
          >
            Cancel
          </button>
          <button
            class="new-btn-color"
            mat-raised-button
            color="primary"
            (click)="saveProfile()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
